
import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
// import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

// function Oataddusermain() {

  

const pageSize =5;

const Tecaddusermain = () => {



  // GET request using fetch()

  
const token = JSON.parse(localStorage.getItem('usertoken'));
const [allusers, setAllusers] = useState([])

const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);
const [Edittec, setEdittec] =useState([])
const[Roletable, setRoletable] =useState([])  

const[SuccessToast,setSuccessToast] = useState(false);  
const[AlreadyErrToast,setAlreadyErrToast] = useState(false);  
const[AlreadyErrToastA,setAlreadyErrToastA] = useState(false);
const[DeleteToast,setDeleteErrToast] = useState(false);

useEffect(()=>{
   //setSuccessToast(true)
  getUsers()
  
}, [])

function getUsers() {
  console.log("Token", token)


  fetch(`${BASE_URL}/Tec/Gettecusers`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data)
      setAllusers(data);
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        }
    );

console.log("check",allusers)
}

const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
// if (pageCount === 1)
// return null;

const pages = _.range(1, pageCount+1)

const pagination =(pageNo)=>{

  // if (pageCount === 1)
// return null;
setcurrentPage(pageNo);
const startIndex = (pageNo - 1) * pageSize;
const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
setpaginatedPosts(paginatedPost)
}
const onNext = () => {


  pagination(currentPage + 1);
};

const onPrevious = () => {
  pagination(currentPage - 1);
};


//function fetch

function fetchdata() 
  {
    
    let data = {
      username:document.getElementById('username').value,
      email:document.getElementById('email').value,
      password:document.getElementById('password').value,
      role:document.getElementById('roleid').value,
      ventureid:'06',
      active:1,
      deleteStatus:0,
      assignStatus:1,
      roleid:'02',
      ventureName:'Kdp Tec'
      
    }
   
    
    axios({

        method:"POST",
        url:`${BASE_URL}/Authenticate/REGISTER`,
        data,
        headers: {
          "Content-Type" : "application/json"
        }

    })
    .then((response) =>{
      console.log(response.data);
      
     
      if(response.data.status === "Success"){
        // toast.success("Registered Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        closeAddForm();
        setSuccessToast(true)
          setTimeout(() => {
            
            getUsers();
          }, 1000);
          setTimeout(() => {
            
            setSuccessToast(false)
          }, 3000);
         
          
       }
       else if(response.data.message === "Username Already Exist"){
        // toast.error("Username Already Exist", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        setAlreadyErrToast(true)
        setTimeout(() => {
            
          setAlreadyErrToast(false)
        }, 4000);
        
      }
      else if(response.data.message === "Email Already Exist"){
        // toast.error("Email Already Exist", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        setAlreadyErrToastA(true)
        setTimeout(() => {
            
          setAlreadyErrToastA(false)
        }, 4000);
      }
   
     
    })
.catch(error => {
  console.log(error);
  alert("User creation failed !")
   
    
 
})
  }


    //validation

    function handleSubmit(event){

      event.preventDefault();
      var name = document.getElementById("username").value;
      var mail = document.getElementById("email").value;
      const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var password = document.getElementById("password").value;
      const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 
      var role = document.getElementById("roleid").value;
    
      if(!name){
            
        document.getElementById("nameErr").innerHTML="Username Required";
      
       
      }
      else if(name.length<3)
      {
        document.getElementById("nameErr").innerHTML=" ";
        document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
        
      }
      else{
        document.getElementById("nameErr").innerHTML=" ";
        document.getElementById("nameErrA").innerHTML=" ";
      }
    
      if(!mail){
    
        document.getElementById("mailErr").innerHTML="Email Required ";    
      }
      else if (email1.test(document.getElementById("email").value)===false){
    
        document.getElementById("mailErrA").innerHTML="Not Valid Email";
        document.getElementById("mailErr").innerHTML=" ";  
     }
      else{
    
        document.getElementById("mailErr").innerHTML="  ";  
        document.getElementById("mailErrA").innerHTML="  ";  
    
      }
      if(!password){
      
        document.getElementById("passErr").innerHTML="Password Required ";    
    
      }
      else if (password1.test(document.getElementById("password").value)===false){
    
        document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
        document.getElementById("passErr").innerHTML=" ";  
     }
      else{
    
        document.getElementById("passErr").innerHTML="  ";  
        document.getElementById("passErrA").innerHTML="  ";  
    
      }
    
      if(!role){
    
        document.getElementById("roleErr").innerHTML="Role Required ";
      }
      else{
    
        document.getElementById("roleErr").innerHTML=" ";
      }

      if((name.length>=3) && (email1.test(document.getElementById("email").value)===true) && (password1.test(document.getElementById("password").value)===true) && role  ){
    
        fetchdata();
      }
    
    }
    
    function handlechange(){
    
      var name = document.getElementById("username").value;
      var mail = document.getElementById("email").value;
      const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var password = document.getElementById("password").value;
      const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 
      var role = document.getElementById("roleid").value;
    
      if(!name){
            
        document.getElementById("nameErr").innerHTML="Username Required";
        document.getElementById("nameErrA").innerHTML=" ";
       
      }
      else if(name.length<3)
      {
        document.getElementById("nameErr").innerHTML=" ";
        document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
        
      }
      else{
        document.getElementById("nameErr").innerHTML=" ";
        document.getElementById("nameErrA").innerHTML=" ";
      }
    
      if(!mail){
    
        document.getElementById("mailErr").innerHTML="Email Required ";
        document.getElementById("mailErrA").innerHTML="  ";      
      }
      else if (email1.test(document.getElementById("email").value)===false){
    
        document.getElementById("mailErrA").innerHTML="Not Valid Email";
        document.getElementById("mailErr").innerHTML=" ";  
     }
      else{
    
        document.getElementById("mailErr").innerHTML="  ";  
        document.getElementById("mailErrA").innerHTML="  ";  
    
      }
      if(!password){
      
        document.getElementById("passErr").innerHTML="Password Required "; 
        document.getElementById("passErrA").innerHTML="  ";     
    
      }
      else if (password1.test(document.getElementById("password").value)===false){
    
        document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
        document.getElementById("passErr").innerHTML=" ";  
     }
      else{
    
        document.getElementById("passErr").innerHTML="  ";  
        document.getElementById("passErrA").innerHTML="  ";  
    
      }
      
      if(!role){
    
        document.getElementById("roleErr").innerHTML="Role Required ";
      }
      else{
    
        document.getElementById("roleErr").innerHTML=" ";
      }
    }

    // popup

    function openForm()
     {

       getRole()
	      document.getElementById("modalRegisterForm").style.display = "block";
      }
      function closeAddForm()
      {
        document.getElementById("nameErr").innerHTML=" ";
        document.getElementById("nameErrA").innerHTML=" ";
        document.getElementById("mailErr").innerHTML="  ";  
        document.getElementById("mailErrA").innerHTML="  ";  
        document.getElementById("passErr").innerHTML="  ";  
        document.getElementById("passErrA").innerHTML="  "; 
        document.getElementById("roleErr").innerHTML=" "; 

        document.getElementById("tecform").reset();
         document.getElementById("modalRegisterForm").style.display = "none";
       }
 
        //password eyeicon
        function hide(){
         
          var x = document.getElementById("password");
          var eye = document.getElementById("eye");
  
          if(x.type === "password"){
  
            x.type = "text";
            eye.classList.remove("fa-eye-slash")
            eye.classList.add("fa-eye")
            
          }
          else{
            x.type = "password";
            eye.classList.remove("fa-eye")
            eye.classList.add("fa-eye-slash")
          }
  
         }
     
         //  ActiveStatus

      //    function ActiveStatus(Id,active,UserName){

   
      //   const body ={
      //    id: Id
      //  }
      //   console.log(body)
      //    axios({
        
      //    method:"POST",
      //   url:`${BASE_URL}/Tec/ActiveStatus`,
      //   data:body,
      //   headers: {
      //   "Content-Type" : "application/json",
      //   "Authorization": "Bearer " + `${token}`
     
      //   }
       
      //    })
      //    .then((response) =>{
      //    console.log(response.data);
      //    if(active != 0) {
      //     toast.info("Activated"+" " + UserName +  "!",{
      //      position: "top-center",
      //      autoClose: 3200,
      //      hideProgressBar: false,
      //      closeOnClick: true,
      //      pauseOnHover: true,
      //      draggable: true,
      //      progress: undefined,
      //      className: 'toast-message'
      //      });
      //      setTimeout(() => {
             
      //       getUsers();
      //      }, 1000);
      //     }
 
      //     else if(active == 0){
      //       toast.info("InActivated"+" " + UserName +  "!", {
      //        position: "top-center",
      //        autoClose: 3200,
      //        hideProgressBar: false,
      //        closeOnClick: true,
      //        pauseOnHover: true,
      //        draggable: true,
      //        progress: undefined,
      //        className: 'toast-message'
      //        });
      //        setTimeout(() => {
               
      //         getUsers();
      //        }, 1000);
      //       }
      //       })
      
      //     }    
          
          //function closeform

          function closeForm(){

            document.getElementById("modaldeleteForm").style.display ="None"

          }
//  deletestatus

function DeleteStatus(Id,UserName){

//confirm delete



  const body ={
   id: Id
 }
  console.log(body)
   axios({
  
  method:"POST",
  url:`${BASE_URL}/Tec/DeleteStatus`,
  data:body,
  headers: {
  "Content-Type" : "application/json",
  "Authorization": "Bearer " + `${token}`

  }
 
   })
   .then((response) =>{
   console.log(response.data);
  //  toast.info(  "Deleted"+" " + UserName +  "!",  {
  //   position: "top-center",
  //   autoClose: 3200,
  //   hideProgressBar: false,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: true,
  //   progress: undefined,
  //   className: 'toast-message'
  //   });
  closeForm();
  setDeleteErrToast(true)
    setTimeout(() => {
     
      getUsers();
      setcurrentPage(1);
    }, 1000);
  
    setTimeout(() => {
     
      getUsers();
      setDeleteErrToast(false)
    }, 3000);
   })
  
   }  
   
   
   ///select particular
  

   function SelectParticular(Id){
    const body =
    {
      
     id:Id
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/Getparticularid`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + `${token}`,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
          setEdittec(response.data)
                
          localStorage.setItem("EditData",JSON.stringify(response.data))
          
       })
       .catch(error => {
         console.log(error);
         
       })

   }
///location change

function edittec(Id){


  SelectParticular(Id)


           
  setTimeout(() => {
    window.location.href="/?#/TecEditpop"
   // window.location.reload()
    
  }, 1000);


}

///confirm delete

function ConfirmDelete(Id){

  SelectParticular(Id)
  setTimeout(() => {
    document.getElementById("modaldeleteForm").style.display = "block";
  },1000);

}

 /*---Get Roles ----*/

 function getRole(){


  fetch(`${BASE_URL}/Tec/GetTecRole`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

        .then(response => response.json())


          .then(data => {
           console.log("Role",data)
           setRoletable(data)
            localStorage.setItem("Data", JSON.stringify(data));
          });
         }
     

        
  return (
      
    <>
    
      <div className='tec-addmain'>


   
     
    <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">USERS</span> </span><div className='tec-addmain-back'>
  <Link to="/Kdp Tec"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div>
 </p> 


 </div>
    </div>



    {/* <div className='tec-addmain-back'>
  <Link to="/Kdptecdashboard"><i class="fa fa-backward" aria-hidden="true" id="tecbackicon"></i></Link>
  </div>
           */}




     {/* Toast */}
    {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Registered Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {AlreadyErrToast?<div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"32%"}}>
  <div id="Tec-error-box">
    <div class="Tec-Toastdot"></div>
    <div class="Tec-Toastdot Tec-Toasttwo"></div>
    <div class="Tec-Toastface2">
      <div class="Tec-Toasteye"></div>
      <div class="Tec-Toasteye Tec-Toastright"></div>
      <div class="Tec-Toastmouth Tec-Toastsad"></div>
    </div>
    <div class="Tec-Toastshadow Tec-Toastmove"></div>
    <div class="Tec-Toastmessage"><h1 class="Tec-Toastalert">Error!</h1><p>Username Already Exist!</p></div>
    
  </div></div></div></div>:null}
   {/* Toast */}
  {AlreadyErrToastA?<div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"32%"}}>
  <div id="Tec-error-box">
    <div class="Tec-Toastdot"></div>
    <div class="Tec-Toastdot Tec-Toasttwo"></div>
    <div class="Tec-Toastface2">
      <div class="Tec-Toasteye"></div>
      <div class="Tec-Toasteye Tec-Toastright"></div>
      <div class="Tec-Toastmouth Tec-Toastsad"></div>
    </div>
    <div class="Tec-Toastshadow Tec-Toastmove"></div>
    <div class="Tec-Toastmessage"><h1 class="Tec-Toastalert">Error!</h1><p>Email Already Exist!</p></div>
    
  </div></div></div></div>:null}
    <div className='tec-addmain-add'>
    <Link to="/TecAddRole"><button className='add-user'>  <i className="fa fa-address-book-o"></i>&nbsp;&nbsp;Add Role</button></Link>
    </div>
    <div className='tec-addmain-add'>
      <button className='add-user' onClick={openForm}>  <i className="fa fa-user-o"></i>&nbsp;&nbsp;Add User</button>
    </div>
    <div className="tec-pop-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"150px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
        <button type="button" className="close" onClick={closeAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form onSubmit={handleSubmit} id="tecform">
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
     
          <input type="text"  className="form-control validate" placeholder='UserName'  onKeyUp={handlechange} id="username" />
          
 
          <span id="nameErr" className='error'></span>
          <span id="nameErrA" className='error'></span>
        </div>
        <div className="md-form mb-5">
          
          <input type="email" className="form-control validate" placeholder='Email' onKeyUp={handlechange} id="email" />
          <span id="mailErr" className='error'></span>
          <span id="mailErrA" className='error'></span>
        </div>

        <div className="md-form mb-5">
        <div style={{display:"flex"}}>
          <input type="password"  className="form-control validate" placeholder='Password' onKeyUp={handlechange} id="password" />
          <span className='tec-profile-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hide} id="eye"></i></span>
          </div>
          <span id="passErr" className='error'></span>
          <span id="passErrA" className='error'></span>

        </div>
        <div className="md-form mb-4">
        <select  name="role"  className="form-select"  onInputCapture={handlechange} id="roleid">
      <option value="">Role</option>
      {/* <option value="02">Team Mate</option> */}
     {Roletable.map((e) => {
      return <option value={e.role}>{e.role}</option>})}
     </select>
      <span id="roleErr" className='error'></span>
      
    </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>

{
   allusers.length==0 ? <div id="TecApiFail">" No Data Found "</div> :(<div>
 <div className='tectable'>

  <div class="tec-table_responsive">
 
  <table className='tecGetuserTable'> 
    <thead>
   <tr>
<th>Username</th>
<th>Email</th>
<th>Action</th>

</tr>
</thead>
<tbody>
{paginatedPosts.map((e,index) => {
      return<tr key={index}>

           <td>{e.userName}</td>
           <td>{e.email}</td>

           <td style={{whiteSpace:"nowrap"}}> 
            {/*{e.active==1 ?<button id ='tecActive-buttonA' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>Active</button>:
              <button id ='tecInActive-buttonB' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>InActive</button>} */}
              &nbsp;&nbsp;
              <span><i class="fa fa-pencil" aria-hidden="true"  onClick={()=>edittec(e.id,e.active,e.userName)} id="tecEditicon"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="tecDelicon"></i></span>
              {/* <button id ='tecDelete-button'  onClick={()=>DeleteStatus(e.id,e.userName)}>Delete</button> */}
              </td>
      </tr>
      })}
</tbody>

</table>



</div>

    </div>
    <br></br>
    {pageCount==1?null: <nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
        {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}

    </div>)}
     {/* DeletePopup */}

   {Edittec.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteStatus(e.id,e.userName)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}

    </div>
  
    </>
  )
}

export default Tecaddusermain
